const img = require('../../../assets/img/background-waves.png');
export default img;
